import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useSeoMeta } from '@/hooks/useSeoMeta';
import { useLocalizedPath } from '@/hooks/useLocalizedPath';

const UPDATED = '2026-06-21';

export default function RefundPage() {
  const { t } = useTranslation();
  const lp = useLocalizedPath();
  useSeoMeta({
    title: t('refund.title') + ' — Lodestar',
    description: t('refund.intro'),
  });
  return (
    <div className="mx-auto max-w-3xl px-4 py-8">
      <Link
        to={lp('/report')}
        className="mb-6 inline-block text-sm text-[color:var(--color-terra-600)] hover:text-[color:var(--color-terra-700)]"
      >
        {t('refund.back')}
      </Link>
      <h1 className="mb-1 font-serif text-3xl font-medium tracking-tight text-[color:var(--color-ink-900)]">
        {t('refund.title')}
      </h1>
      <p className="qa-meta mb-6">{t('refund.updated', { date: UPDATED })}</p>

      <article className="prose prose-sm max-w-none space-y-4 text-slate-700">
        <p>{t('refund.intro')}</p>

        <h2 className="text-lg font-semibold text-slate-800">{t('refund.s1.title')}</h2>
        <p>{t('refund.s1.body')}</p>

        <h2 className="text-lg font-semibold text-slate-800">{t('refund.s2.title')}</h2>
        <p>{t('refund.s2.lead')}</p>
        <ul className="list-disc pl-5">
          <li>{t('refund.s2.i1')}</li>
          <li>{t('refund.s2.i2')}</li>
          <li>{t('refund.s2.i3')}</li>
        </ul>
        <p>{t('refund.s2.how')}</p>

        <h2 className="text-lg font-semibold text-slate-800">{t('refund.s3.title')}</h2>
        <p>{t('refund.s3.body')}</p>

        <h2 className="text-lg font-semibold text-slate-800">{t('refund.s4.title')}</h2>
        <p>{t('refund.s4.body')}</p>

        <h2 className="text-lg font-semibold text-slate-800">{t('refund.s5.title')}</h2>
        <p>
          {t('refund.s5.before')}
          <a href="mailto:hello@lodestar.place" className="text-blue-600 hover:underline">
            {t('refund.s5.email')}
          </a>
          {t('refund.s5.after')}
        </p>
      </article>
    </div>
  );
}
